import { Component, Input } from '@angular/core';
import { EventItemDetails } from 'src/app/events-v4/shared/items/event-item-details.model';
import { EventItemSearchDto } from 'src/app/events-v4/shared/items/event-item-search.dto';
import { EventV4ItemService } from 'src/app/events-v4/shared/items/event-v4-item.service';
import { DatagridService, PagedResult, PagedResultGeneric } from 'src/app/shared';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';

@Component({
  selector: 'wl-event-v4-item-details-modal',
  templateUrl: './event-v4-item-details-modal.component.html',
  styleUrl: './event-v4-item-details-modal.component.less',
    standalone: false
})
export class EventV4ItemDetailsModalComponent extends LazySelectableTableComponent<EventItemSearchDto, EventItemDetails> {
  show: boolean = false;
  exporting: boolean = false;

  constructor(
    private _eventItemService: EventV4ItemService,
    private _navigationService: NavigationService,
    datagridService: DatagridService
  ) {
    super('', datagridService);
    this.searchParams = {
      PageNumber: 1,
      PageSize: 0,
    } as EventItemSearchDto;
  }

  public open(eventId: number) {
    this.show = true;
    this.searchParams.eventId = eventId;
    this.search();
  }

  public close() {
    this.show = false;
  }

  fetchResults(): Promise<PagedResultGeneric<EventItemDetails>> {
    return this._eventItemService.getEventItemDetails(this.searchParams).then((result) => {
      return result;
    });
  }

  public exportItems() {
    this.exporting = true;
    this._eventItemService
      .exportEventItemDetails(this.searchParams)
      .then((csvUrl) => {
        this._navigationService.popupSafeNavigate(csvUrl);
      })
      .finally(() => {
        this.exporting = false;
      });
  }
}
